import { Typography } from 'antd';
import classNames from 'classnames';
import CustomTooltip from '../../customTooltip';
import './style.scss';
import type { TooltipFormatterProps } from './types';
import { useTooltipFormatter } from './useTooltipFormatter';

const { Paragraph } = Typography;

const TooltipFormatter = ({
  text = '',
  rows = 2,
  className = undefined,
}: TooltipFormatterProps) => {
  const { truncated, setTruncated } = useTooltipFormatter();

  return (
    <CustomTooltip
      title={truncated ? text : undefined}
      placement="bottom"
      classNames={{ root: 'tooltip-formatter' }}
      mouseLeaveDelay={0}
      mouseEnterDelay={0}
    >
      <Paragraph
        className={classNames('tooltip-text', className)}
        style={
          truncated
            ? {
                marginBottom: 0,
                cursor: 'pointer',
              }
            : {
                marginBottom: 0,
              }
        }
        ellipsis={{
          rows,
          expandable: false,
          onEllipsis: setTruncated,
        }}
      >
        {text}
      </Paragraph>
    </CustomTooltip>
  );
};

export default TooltipFormatter;
